<!-- Translated: yes -->
<template>
  <div>
    <Loading :show="loading" :text="$t('general.cancelling')" />
    <div :class="{loading: loading}">
      <div class="cancel-info" v-if="!purchaseCompleted">
        <p><span id="cancel-info-span">{{ $t('general.payment.fill-details') }}</span><br ><button @click="cancel()" class="small white border">{{ $t('general.payment.cancel') }}</button></p>
      </div>
      <div class="danish-info" v-if="!purchaseCompleted">
        <p style="text-align:center;margin: 0.5em 1em;" v-html="$t('general.contact_guest_service.payment', { phone: '<a href=\'tel:054-13 26 00\'>054-13 26 00</a>'})" />
      </div>
      <BookingTimer :currently-paying="true" @cancel="cancel()"></BookingTimer>
      <br />
      <KlarnaCheckout
        v-if="SITE_CONFIG.payment_service === 'klarna'"
      ></KlarnaCheckout>
      <CollectorCheckout
        v-else-if="SITE_CONFIG.payment_service === 'collector'"
        v-on:purchase-completed="handlePurchaseCompleted"
      ></CollectorCheckout>
      <div v-else>There’s no configured payment service ({{ SITE_CONFIG.payment_service }})</div>
    </div>
    <OrderCheckForCancellation />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

import CollectorCheckout from '@/components/payments/CollectorCheckout';
import KlarnaCheckout from '@/components/payments/KlarnaCheckout';
import OrderCheckForCancellation from '@/components/payments/OrderCheckForCancellation';
import Loading from '@/components/components/Loading';
import BookingTimer from '@/components/components/BookingTimer';
import API from '@/classes/API';

export default {
  props: {
  },
  components: {
    CollectorCheckout,
    KlarnaCheckout,
    Loading,
    OrderCheckForCancellation,
    BookingTimer,
  },
  data() {
    return {
      loading: false,
      country: 'se',
      purchaseCompleted: false,
    };
  },
  async mounted() {
    this.$root.$on('cancel-payment', () => {
      this.cancel();
    });

    const orderId = this.$route.query.order || 0;
    const code = this.$route.query.code || '';
    const { data } = await API.get(`/orders/get?order=${orderId}&code=${code}`);

    this.country = data.country;
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
      'closeAllModals',
    ]),
    cancel() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: this.$i18n.t('general.are-you-sure'),
        content: this.$i18n.t('general.cancel-payment'),
        buttons: [
          {
            title: this.$i18n.t('general.yes'),
            class: 'small',
            click: () => {
              $this.loading = true;
              $this.closeAllModals();
              $this.doCancel();
            },
          },
          {
            title: this.$i18n.t('general.no'),
            class: 'small white border',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    async doCancel() {
      this.loading = true;
      await API.post(`cancel-order/${this.$route.query.order}/${this.$route.query.code}`);
      this.loading = false;
      this.$router.replace('/varukorg');
    },
    handlePurchaseCompleted({ checkout_session_id }) {
      // Temporary fix ?
      const extraFrame = document.querySelector('body > div > .collector-checkout-iframe');

      this.purchaseCompleted = true;

      if (extraFrame) {
        extraFrame.remove();
      }

      this.$router.replace({ path: '/betala/bekraftelse', query: { checkout_session_id } });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.loading
  disabled()

.cancel-info
  max-width: 640px;
  width 100%
  margin 0 auto
  margin-top 25px
  margin-bottom 0
  padding 15px
  text-align: center;
  button
    margin-top 10px

.danish-info
  img
    float left
    margin-right 10px
    width 71px
    height 41px

  max-width: 640px;
  width 100%
  margin 0 auto
  margin-top 25px
  margin-bottom 10px
  padding 15px
  border-radius: 3px;
  background-color: rgba(239, 222, 174, 0.49);
  border: solid 1px #ffb320;

  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2c2f34;
</style>



// WEBPACK FOOTER //
// PaymentPage.vue?665e6efc